import { Inject, Injectable } from '@angular/core';

import type { UnaryFunction } from 'rxjs';
import { pipe, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { COMPANY_ID } from '@core/common-legacy';
import type { HttpApiErrorHandlerService } from '@core/http-legacy';
import { AuthService } from '@core/http-legacy';

@Injectable()
export class WebappHttpApiErrorHandlerService implements HttpApiErrorHandlerService {
  public internalServerError$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    @Inject(COMPANY_ID) private currentCompanyId: number,
  ) {}

  public handleError(url: string, preventDefault?: boolean): UnaryFunction<any, any> {
    if (preventDefault) return pipe();

    return pipe(
      catchError(error => {
        switch (error.status) {
          case 401:
            this.authService.onUnauthorized(error);
            break;
          case 403:
            this.authService.onForbidden(error, this.currentCompanyId, url);
            break;
          case 500:
            this.internalServerError$.next(error);
            break;
          default:
            break;
        }
        return throwError(error);
      }),
    );
  }
}
